// Factories Mutations

export const updateFactoriesList = (state, payload) => {
  state.factoriesList = payload
}

export const fetchFactoryInfo = (state, payload) => {
  state.factoryInfo = payload
}

export const updateFullFactoriesList = (state, payload) => {
  state.fullFactoriesList = payload
}
